export default __webpack_public_path__ + "static/media/dai_logo.1096719c.svg";